/**
 * TIER-3 Phase 0 — frontend mirror of backend/tierPolicy.js + the TIER_RANK
 * ordering (backend/authMiddleware.js). Design doc §6.1: "keep it a tiny
 * hand-mirrored constant with a parity test" — NOT generated (unlike the
 * ADR-008 distribution engine; this map is small enough that generation would
 * be more machinery than the thing it protects). frontend/src/tierPolicy.test.js
 * is what keeps this file honest against the backend source of truth.
 *
 * Never edit this file without updating backend/tierPolicy.js (FEATURE_TIERS)
 * and/or backend/authMiddleware.js (TIER_RANK) in the SAME commit.
 */

export const TIER_RANK = { free: 0, paid: 1, enterprise: 2, admin: 3 };

/** @type {Record<string, 'free'|'paid'|'enterprise'|'admin'>} */
export const FEATURE_TIERS = {
    parts: 'paid',
    rtSpc: 'paid',
    workOrders: 'enterprise',
    erpImport: 'enterprise',
    apiKeys: 'enterprise',
    tagApi: 'enterprise',
};

/**
 * @param {string} tier
 * @param {string} minTier
 * @returns {boolean}
 */
export function isAtLeast(tier, minTier) {
    const tierRank = TIER_RANK[tier];
    const minRank = TIER_RANK[minTier];
    if (tierRank === undefined || minRank === undefined) return false;
    return tierRank >= minRank;
}

/**
 * @param {string} tier
 * @param {keyof typeof FEATURE_TIERS} feature
 * @returns {boolean}
 */
export function hasFeature(tier, feature) {
    const minTier = FEATURE_TIERS[feature];
    if (!minTier) return false;
    return isAtLeast(tier, minTier);
}
